import React from 'react';
import { t } from 'ttag';
import PropTypes from 'prop-types';

function Body({ children, headerInformation, isMobile }) {
  return (
    <div
      className="fixed inset-y-0 right-0 z-[105] flex w-screen flex-col overflow-y-scroll bg-white md:bottom-0 md:z-20 md:w-[470px]"
      role="dialog"
      aria-labelledby={t`Customization Overlay`}
      aria-describedby={t`This Overlay allows you to customize your product`}
      style={
        headerInformation.visible && !isMobile
          ? { top: `${headerInformation.height}px` }
          : { top: '0px' }
      }
    >
      {children}
    </div>
  );
}

Body.propTypes = {
  children: PropTypes.node.isRequired,
  headerInformation: PropTypes.shape({
    visible: PropTypes.bool,
    height: PropTypes.number,
  }).isRequired,
};

Body.defaultProps = {};

export default Body;
